import { StatsColumn } from "./stats-column";

// Définitions des colones pour la page des statistiques
export const statsColums: StatsColumn[] = [
  { id: 'article', libelle: 'Article' },
  { id: 'libelle', libelle: 'Libellé' },
  { id: 'libelleArticle', libelle: 'Désignation article' },
  { id: 'qt_sem', libelle: 'Moyenne hebdo', type: 'number' },
  { id: 'qt_sem_1_traitees', libelle: 'Quantité sur les 5 plus grosses semaines' },
  { id: 'qt_sem_2_traitees', libelle: '' },
  { id: 'qt_sem_3_traitees', libelle: '' },
  { id: 'qt_sem_4_traitees', libelle: '' },
  { id: 'qt_sem_5_traitees', libelle: '' },
  { id: 'qt_mab', libelle: 'Qté Mise à Blanc', type: 'number' },
  { id: 'qt_theo', libelle: 'Stock théorique', type: 'number' },
  { id: 'stock', libelle: 'Stock déposé', type: 'number' },
  { id: 'qt_diff', libelle: 'Ecart', type: 'number' },
  { id: 'numPorteur', libelle: 'N° utilisateur', type: 'string' },
  { id: 'TAI_UTL', libelle: 'N° utilisateur' },
  { id: 'porteur', libelle: 'Utilisateur' },
  { id: 'casier', libelle: 'Casier' },
  { id: 'UTL_LIB', libelle: 'Utilisateur' },
  { id: 'TAI_CLF', libelle: 'Casier' },
  { id: 'codeArticle', libelle: 'Code article' },
  { id: 'TAI_COD', libelle: 'Code article' },
  { id: 'TAI_TAI', libelle: 'Taille', type: 'number' },
  { id: 'designation', libelle: 'Désignation article' },
  { id: 'ART_DES', libelle: 'Désignation article' },
  { id: 'TAI_STC', libelle: 'Stock', type: 'number' },
  { id: 'TAI_STS', libelle: 'Change hebdo', type: 'number' },
  { id: 'dateDernierLavage', libelle: 'Dernière livraison prévue' },
  { id: 'cabJeu', libelle: 'Jeu' },
  { id: 'action', libelle: 'Action' },
  { id: 'cabNum', libelle: 'ID Vts' },
  { id: 'tx_rot', libelle: 'TxRot', type: 'number' },
  { id: 'taille', libelle: 'Taille' },
  { id: 'nbLavages', libelle: 'NB Lav/Sem' },
  { id: 'lavage_0', libelle: '5 derniers lavages' },
  { id: 'lavage_1', libelle: '' },
  { id: 'lavage_2', libelle: '' },
  { id: 'lavage_3', libelle: '' },
  { id: 'lavage_4', libelle: '' },
  { id: 'tailleStock', libelle: 'Stock', type: 'number' },
  { id: 'cabEtat', libelle: 'Etat' },
  { id: 'type', libelle: 'Type' },
  { id: 'ligne', libelle: 'Ligne' },
  { id: 'regleFacturation', libelle: 'R-F' },
  { id: 'designationArticle', libelle: 'Désignation article' },
  { id: 'dateM', libelle: 'Date' },
  { id: 'quantite', libelle: 'Quantité', type: 'number' },
  { id: 'TAI_QTS', libelle: 'Change hebdo prévu', type: 'number' },
  { id: 'TAI_QTP', libelle: 'Stock prévu', type: 'number' },
  { id: 'TAI_REG', libelle: 'Règle facturation' },
  { id: 'cal', libelle: 'CAL 4 S' }
];
